import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { HISCOX_BOP_DECLARATION, HISCOX_CYBER_DECLARATION, HISCOX_PI_DECLARATION, HISCOX_PL_DECLARATION } from '../../constants';
import { getLocalTranslation } from '../../utils/i18nKit';
export var getHiscoxUSInsuranceQuoteQuestionInfoMap = function getHiscoxUSInsuranceQuoteQuestionInfoMap() {
  var _ref;

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return _ref = {
    hiscox_professional_liability_policy_question: {
      title: 'Do you currently have a Professional Liability policy?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    hiscox_professional_liability_retroactive_date_available_question: {
      title: 'Do you have the retroactive date of your current Professional Liability policy?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    hiscox_tangible_goods_or_products_question: {
      title: 'Do you or your business supply, manufacture, or distribute any tangible goods or products?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    hiscox_products_manufactured_by_others_question: {
      title: 'Are the products you provide as part of your services limited to those manufactured by others and do the total sales from these products represent less than 25% of your estimated gross sales?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    hiscox_limited_items_part_of_services_question: {
      title: 'Is this limited to items like computer equipment and peripherals, brochures, and documents that form part of the services provided?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    hiscox_it_consulting_or_technology_services: {
      title: 'Your business DOES NOT provide any of the following IT consulting or technology services:',
      confirmType: '1',
      spec: [{
        text: '',
        list: [{
          text: 'Game developer'
        }, {
          text: 'Internet search engine'
        }, {
          text: 'Smartphone/mobile phone/tablet application development'
        }]
      }]
    },
    hiscox_operated_from_home_question: {
      title: 'Is your business operated out of your home, at this location?',
      confirmType: '2',
      spec: [],
      reverse: true
    },
    hiscox_building_ownership_question: {
      title: 'Does your business own and need coverage for the building?',
      confirmType: '3',
      spec: [],
      reverse: true
    },
    hiscox_risk_management_question: {
      title: '',
      confirmType: '1',
      spec: [{
        text: 'Risk Management',
        list: [{
          hideDot: true,
          text: 'Your business implements measures to manage risk. Such as:',
          list: [{
            text: 'Client contracts with indemnitifcation clauses'
          }, {
            text: 'sign-off on deliverable'
          }, {
            text: 'formal change management procedures'
          }]
        }]
      }]
    },
    hiscox_declaration_p1: {
      title: '',
      confirmType: '1',
      spec: []
    }
  }, _defineProperty(_ref, HISCOX_PI_DECLARATION, {
    title: '',
    confirmType: '1',
    spec: []
  }), _defineProperty(_ref, HISCOX_PL_DECLARATION, {
    title: '',
    confirmType: '1',
    spec: []
  }), _defineProperty(_ref, HISCOX_CYBER_DECLARATION, {
    title: '',
    confirmType: '1',
    spec: []
  }), _defineProperty(_ref, HISCOX_BOP_DECLARATION, {
    title: '',
    confirmType: '1',
    spec: []
  }), _defineProperty(_ref, "hiscox_annual_privacy_matters_training_question", {
    title: "Do you conduct annual training for employees with respect to privacy matters?",
    confirmType: '2',
    spec: []
  }), _defineProperty(_ref, "hiscox_design_construction_repair_question_1", {
    title: 'Does your business perform any design, construction, installation, removal, or physical repair of any property or tangible good?',
    confirmType: '2',
    spec: [],
    reverse: true
  }), _defineProperty(_ref, "hiscox_design_construction_repair_question_2", {
    title: 'Is this limited to the installation, removal, or repair of software, hardware, computer equipment and other technology peripherals?',
    confirmType: '2',
    spec: [],
    reverse: true
  }), _defineProperty(_ref, "hiscox_subcontract_professional_services_question_1", {
    title: 'Does your business subcontract any professional services?',
    confirmType: '2',
    spec: [],
    reverse: true
  }), _defineProperty(_ref, "hiscox_subcontract_professional_services_question_2", {
    title: 'Do you agree with the following statements about your subcontracted services?',
    confirmType: '1',
    spec: [{
      list: [{
        text: 'You only subcontract design-related architectural, drafting, or engineering services.'
      }, {
        text: 'You do not subcontract physical construction or repair services.'
      }, {
        text: 'You do not subcontract any other services.'
      }, {
        text: 'You require subcontractors you hire to purchase their own insurance.'
      }]
    }]
  }), _ref;
};
export var getHiscoxQuoteExtraQuestionCheckboxInfoMap = {
  itConsultingOrTechnologyServices: {
    title: 'What IT consulting or technology services does your business provide from the following list?',
    list: [{
      value: 'Game developer',
      label: 'Game developer',
      text: 'Game developer',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Game developer'
    }, {
      value: 'Internet search engine',
      label: 'Internet search engine',
      text: 'Internet search engine',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Internet search engine'
    }, {
      value: 'Smartphone/mobile phone/tablet application development',
      label: 'Smartphone/mobile phone/tablet application development',
      text: 'Smartphone/mobile phone/tablet application development',
      hideDot: true,
      showCheckbox: false,
      checked: false,
      uniqueId: 'Smartphone/mobile phone/tablet application development'
    }]
  }
};